import React, { useContext, useEffect, useState } from "react";
import Tabs from "../../Common/Tabs";
import {
  CHANNEL_ERROR,
  Constants,
  connectionHeaders,
  connectionTableApi,
  connectionTableHeaders,
} from "./Constants";
import Table from "../../Common/Table/Table";
import { AppContext } from "../../../Context/AppContext";
import "./Connection.css";

import { CSSTransition } from "react-transition-group";
import GMSFillButton from "../../Common/components/GMSFillButton";
import DataImportForm from "./DataImportForm";
import ServiceWrapper from "../../../Services/ServiceWrapper";
import AuthManager from "../../../Common/AuthManager";
import GMSButton from "../../Common/components/GMSButton";
import ConnectionLogs from "./ConnectionLogs";
import NoData from "./NoData";
import { toast } from "react-toastify";
import useTable from "../../Common/Table/useTable";
import { useHistory } from "react-router-dom";
import BootBoxManager from "../../../Common/BootBoxManager";
import ConfigurationPanel from "./ConfigurationPanel";
import CompatioLoader from "Components/Common/components/CompatioLoader";

// @todo replace
const MID_WAY_URL = process.env.REACT_APP_CONNECTION_API;
// const MID_WAY_URL = "https://midway-connector-dev.compatio.net/"
const ConnectionsHome = () => {
  // app context
  const appData = useContext(AppContext);

  const _defaultModule = "Related Products";
  const [currentTab, setCurrentTab] = useState(null);

  const history = useHistory();


  const current_party_id = JSON.parse(localStorage.getItem("current_party_id"));

  const [showImportDataForm, setShowImportDataForm] = useState(false);
  const [showConfigurationPanel, setShowConfigurationPanel] = useState(false);

  const [loading, setLoading] = useState(false);
  const [recordPerPage, setRecordPerPage] = useState(100);
  const [page, setPage] = useState(1);

  const [viewLog, setViewLog] = useState(false);
  const [logDataIndex, setLogDataIndex] = useState(undefined);
  const [canImportData, setCanImportData] = useState(false);
  const [loadingConfiguration, setLoadingConfiguration] = useState(false);
  const [gmsEndpoint, setGmsEndpoint] = useState(undefined);

  const { headers, data, sort, setHeaders, setData, handleSortByColumn } =
    useTable({ table_headers: connectionHeaders });

  // Helper function to check version
  const isVersionGreaterOrEqual = (version, targetVersion) => {
    if (!version) return false;
    const versionNumber = parseFloat(version.replace('v', ''));
    return versionNumber >= targetVersion;
  };

  // Get API path based on current tab and version
  const getApiPath = (tab) => {
    // For Related Products tab, use version-based routing
    if (tab === "Related Products") {
      return isVersionGreaterOrEqual(gmsEndpoint, 3)
        ? "logs/relatedproducts"
        : "logs/accessories";
    }
    // For other tabs, use standard routing
    return connectionTableApi[tab];
  };

  /**
   * handle tab change
   *
   * @param {string} tab - tab label
   */
  const handleTabChange = (tab) => {
    setCurrentTab((prevtab) => {
      // if the tab is same useeffect will not trigger data fetch
      if (prevtab === tab) fetchData();
      return tab;
    });
    closeAllPanels();
  };


  const closeAllPanels = () => {
    setShowImportDataForm(false);
    setShowConfigurationPanel(false);
    setViewLog(false);
  };

  const fetchConfiguration = async () => {
    try {
      setLoadingConfiguration(true)
      const res = await ServiceWrapper.doGet(
        `${MID_WAY_URL}configuration/${appData?.channelKey}`,
        null,
        null,
        AuthManager.getGmsToken()
      );
      if (res?.data?.done) {
        setGmsEndpoint(res.data?.data?.gms_endpoint);
        setCanImportData(true);

        // Set default tab only if not already set
        if (!currentTab) {
          setCurrentTab(_defaultModule);
        }
      } else {
        setGmsEndpoint(undefined);
        setCanImportData(false);

        // Set default tab even if configuration fails
        if (!currentTab) {
          setCurrentTab(_defaultModule);
        }
      }
    }
    finally {
      setLoadingConfiguration(false);
    }
  };

  const fetchData = async () => {
    if (!currentTab) return;
    setLoading(true);
    const apiPath = getApiPath(currentTab);

    let res = await ServiceWrapper.doGet(
      `${MID_WAY_URL}connection/${appData?.channelKey}/${apiPath}`,
      null,
      null,
      AuthManager.getGmsToken()
    );

    if (res?.errorfound || res?.data?.done === false) {
      toast.error(`Error loading ${currentTab.toLowerCase()} list`);
      setLoading(false);
      return;
    }

    setData(res.data.data);
    setLoading(false);
  };

  useEffect(() => {
    if (appData.pm.checkPermission("connectionmanager_read")) {
      setHeaders(connectionTableHeaders[currentTab]);
      if (appData?.channelKey) {
        fetchData();
        fetchConfiguration();
      } else {
        console.error(CHANNEL_ERROR);
      }
    } else {
      history.push("/workspace/module/permission/denied");
    }
  }, [currentTab, appData?.channelKey]);

  const handleViewLog = (index) => {
    setViewLog(true);
    setLogDataIndex(index);
  };

  const handleRecordPerPageChange = (perPage) => {
    setRecordPerPage(perPage);
    setPage(1);
  };

  const handleDelete = async (e, id, callback) => {
    e.preventDefault();
    BootBoxManager.confirm(
      "Delete Schedule?",
      `Do you really want to delete the Schedule ? This cannot be undone.`,
      false,
      [
        async () => {
          callback && (await callback(id, fetchData));
        },
      ]
    );
  };

  if (loadingConfiguration && !gmsEndpoint) return <CompatioLoader />
  return (
    <>
      <div className="tw-flex tw-justify-between tw-items-center">
        <label className="title">Manage Connections</label>
        <div className="tw-left-1">

        </div>
        <div className="d-flex">
          <button
            type="button"
            className="btn btn-light btn-sm"
            style={{
              color: "#091caa",
              background: "none",
              border: "none",
              boxShadow: "none",
            }}
            onClick={() => {
              closeAllPanels();
              fetchData();
            }}
          >
            <i className="fa fa-sync-alt" />
          </button>
          <div className="ms-2"></div>

          <GMSButton
            name="Configuration"
            onClick={() => setShowConfigurationPanel(true)}
          />
          <div className="ms-2"></div>
          <GMSFillButton
            name="Data Import"
            disabled={!canImportData}
            onClick={() => {
              if (appData.pm.checkPermission("connectionmanager_trigger")) {
                setShowImportDataForm(true);
              } else {
                toast.info("You do not have permission to import data.");
              }
            }}
          />
        </div>
      </div>
      {currentTab && (
        <>
          <Tabs
            tabs={Constants.Tabs}
            current={currentTab}
            handleTabChange={handleTabChange}
          />

          <Table
            headers={headers}
            recordPerPage={recordPerPage}
            setRecordPerPage={handleRecordPerPageChange}
            handlePageChange={setPage}
            data={data}
            loading={loading}
            handleSortByColumn={handleSortByColumn}
            sort={sort}
            page={page}
            handleViewLog={handleViewLog}
            handleDelete={handleDelete}
            NoDataComponent={() => (
              <NoData
                module={currentTab}
                canImportData={canImportData}
                setShowImportDataForm={setShowImportDataForm}
              />
            )}
          />
        </>
      )}

      {viewLog && data[logDataIndex] && (
        <CSSTransition
          timeout={1000}
          key={showImportDataForm}
          classNames={{
            enterActive: "animate__animated animate__flipInX",
            exitActive: "animate__animated animate__flipOutX",
          }}
        >
          <ConnectionLogs
            logData={data[logDataIndex].logs}
            logId={data[logDataIndex].uid}
            setViewLog={setViewLog}
          />
        </CSSTransition>
      )}

      {showImportDataForm && (
        <CSSTransition
          timeout={1000}
          key={showImportDataForm}
          classNames={{
            enterActive: "animate__animated animate__flipInX",
            exitActive: "animate__animated animate__flipOutX",
          }}
        >
          <DataImportForm
            setShowImportDataForm={setShowImportDataForm}
            setCurrentTab={handleTabChange}
            fetchData={fetchData}
            gmsEndpoint={gmsEndpoint}
          />
        </CSSTransition>
      )}

      {showConfigurationPanel && (
        <CSSTransition
          timeout={1000}
          key={showConfigurationPanel}
          classNames={{
            enterActive: "animate__animated animate__flipInX",
            exitActive: "animate__animated animate__flipOutX",
          }}
        >
          <ConfigurationPanel
            setShowConfigurationPanel={setShowConfigurationPanel}
            callback={fetchConfiguration}
          />
        </CSSTransition>
      )}
    </>
  );
};

export default ConnectionsHome;